import { render, staticRenderFns } from "./VProjectIntroduction.vue?vue&type=template&id=a2e3612e&"
import script from "./VProjectIntroduction.vue?vue&type=script&lang=js&"
export * from "./VProjectIntroduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports